import PropTypes from 'prop-types';
import { TITLE_CONTAINER_LABEL_POSITIONS } from '@/constants/homepage';

export const TitleContainer = ({ labelPosition = TITLE_CONTAINER_LABEL_POSITIONS.TOP, label = '', children }) => {
  const isLabelLeft = labelPosition === TITLE_CONTAINER_LABEL_POSITIONS.LEFT;

  return (
    <div className={`title-container${isLabelLeft ? ' label-is-left-position' : ''}`} data-test-id="title-container">
      <div className={`title-container-label-${labelPosition}`} >
        <div className={`title-container-html-content label-${labelPosition}`} dangerouslySetInnerHTML={{ __html: label }} />
      </div>
      <div className="title-container-children">
        {children}
      </div>
    </div>
  );
};

TitleContainer.propTypes = {
  label: PropTypes.string,
  labelPosition: PropTypes.oneOf(Object.values(TITLE_CONTAINER_LABEL_POSITIONS)),
  children: PropTypes.object.isRequired
};

export default TitleContainer;
